module.exports = __webpack_public_path__ + "static/media/ex-conditional-icon1.67de5328.svg";